import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.comeCount = ''
      this.months = ''
      this.searchCon = ''
    }
  }
}
export default searchFrom
